<template>
  <div class="mv-container">
    <div class="mv-wrap">
      <h3 class="title">mv详情</h3>
      <div class="video-wrap">
        <video
            controls
            autoplay
            :src="mvUrl"
        ></video>
      </div>
      <div class="info-wrap">
        <div class="singer-info">
          <div class="avatar-wrap">
            <img :src="artist.picUrl" alt=""/>
          </div>
          <span class="name">{{ artist.name }}</span>
        </div>
        <div class="mv-info">
          <h2 class="title">{{ mvDetail.name }}</h2>
          <span class="date">发布：{{ mvDetail.publishTime }}</span>
          <span class="number">播放：{{ mvDetail.playCount }}次</span>
          <p class="desc">
            {{ mvDetail.desc }}
          </p>
        </div>
      </div>
      <div class="comment-wrap" v-if="hotComments.length != 0">
        <p class="title">精彩评论<span class="number">({{ hotComments.length }})</span></p>
        <div class="comments-wrap">
          <div class="item" v-for="(item,index) in hotComments" :key="index">
            <div class="icon-wrap">
              <img :src="item.user.avatarUrl" alt=""/>
            </div>
            <div class="content-wrap">
              <div class="content">
                <span class="name">{{ item.user.nickname }}：</span>
                <span class="comment">{{ item.content }}</span>
              </div>
              <div class="re-content" v-if="item.beReplied.length != 0">
                <span class="name">{{ item.beReplied[0].user.nickname }}</span>
                <span class="comment">{{ item.beReplied[0].content }}</span>
              </div>
              <div class="date">{{ new Date(item.time).toLocaleString() }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="comment-wrap">
        <p class="title">最新评论<span class="number">({{ total }})</span></p>
        <div class="comments-wrap">
          <div class="item" v-for="(item,index) in comments" :key="index">
            <div class="icon-wrap">
              <img :src="item.user.avatarUrl" alt=""/>
            </div>
            <div class="content-wrap">
              <div class="content">
                <span class="name">{{ item.user.nickname }}：</span>
                <span class="comment">{{ item.content }}</span>
              </div>
              <div class="re-content" v-if="item.beReplied.length != 0">
                <span class="name">{{ item.beReplied[0].user.nickname }}</span>
                <span class="comment">{{ item.beReplied[0].content }}</span>
              </div>
              <div class="date">{{ new Date(item.time).toLocaleString() }}</div>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
          @current-change="handleCurrentChange"
          background
          layout="prev, pager, next"
          :total="total"
          :current-page="page"
          :page-size="5"
          :limit="limit"
      >
      </el-pagination>
    </div>
    <div class="mv-recommend">
      <h3 class="title">相关推荐</h3>
      <div class="mvs">
        <div class="items">
          <div class="item" v-for="(item,index) in mvs" :key="index" @click="toMvlist(item.id)">
            <div class="img-wrap">
              <img :src="item.cover" alt=""/>
              <span class="iconfont icon-play"></span>
              <div class="num-wrap">
                <div class="iconfont icon-play"></div>
                <div class="num">{{ item.playCount }}</div>
              </div>
              <span class="time">{{ item.duration }}</span>
            </div>
            <div class="info-wrap">
              <div class="name">{{ item.name }}</div>
              <div class="singer">{{ item.artistName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'mv',
  data() {
    return {
      total: 20,
      page: 1,
      limit: 10,
      id: this.$route.query.q,
      artist: {},
      mvUrl: "",
      mvDetail: {},
      mvs: [],
      hotComments: [],
      comments: [],
    };
  },
  watch: {
    id() {
      this.loadPage()
      this.page = 1
    }
  },
  created() {
    this.loadPage()
  },
  methods: {
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val
      axios({
        url: 'http://120.76.129.1:3000/comment/mv',
        method: 'get',
        params: {
          id: this.id,
          limit: this.limit,
          offset: (this.page - 1) * this.limit
        }
      }).then(res => {
        console.log(res)
        this.comments = res.data.comments
      })
    },
    toMvlist(id) {
      this.id = id
      this.$router.push('/mv?q=' + id)
    },
    loadPage() {
      axios({
        url: 'http://120.76.129.1:3000/mv/url',
        method: 'get',
        params: {
          id: this.id
        }
      }).then(res => {
        console.log(res)
        this.mvUrl = res.data.data.url
      })
      axios({
        url: 'http://120.76.129.1:3000/mv/detail',
        method: 'get',
        params: {
          mvid: this.id
        }
      }).then(res => {
        // console.log(res)
        this.mvDetail = res.data.data
        if (this.mvDetail.playCount >= 10000) {
          this.mvDetail.playCount = parseInt(this.mvDetail.playCount / 10000) + '万'
        }
        let singleId = res.data.data.artists[0].id
        axios({
          url: 'http://120.76.129.1:3000/artists',
          method: 'get',
          params: {
            id: singleId
          }
        }).then(res => {
          console.log(res)
          this.artist = res.data.artist
        })
      })
      axios({
        url: 'http://120.76.129.1:3000/simi/mv',
        method: 'get',
        params: {
          mvid: this.id
        }
      }).then(res => {
        console.log(res)
        this.mvs = res.data.mvs
        for (let i = 0; i < this.mvs.length; i++) {
          if (this.mvs[i].playCount >= 10000) {
            this.mvs[i].playCount = parseInt(this.mvs[i].playCount / 10000) + '万'
            let duration = this.mvs[i].duration
            let min = parseInt(duration / 1000 / 60)
            if (min < 10) {
              min = '0' + min;
            }
            let sec = parseInt(duration / 1000 % 60)
            if (sec < 10) {
              sec = '0' + sec;
            }
            this.mvs[i].duration = `${min}:${sec}`
          }
        }
      })
      axios({
        url: 'http://120.76.129.1:3000/comment/mv',
        method: 'get',
        params: {
          id: this.id,
          limit: this.limit,
          offset: (this.page - 1) * this.limit
        }
      }).then(res => {
        console.log(res)
        this.hotComments = res.data.hotComments
        this.comments = res.data.comments
        this.total = res.data.total
      })
    }
  }
};
</script>

<style></style>
